<div class="dd-app-root">
  <div *ngIf="isLoading$ | async">
    <dd-app-loading></dd-app-loading>
  </div>
  <dd-app-header [sharedData]="sharedData"></dd-app-header>
  <div>
    <router-outlet></router-outlet>
  </div>
  <dd-app-footer [sharedData]="sharedData"></dd-app-footer>
</div>
